import React from 'react';
import {Button, Modal, Form, FormGroup, ControlLabel, FormControl, Glyphicon, Checkbox} from 'react-bootstrap';
import { ALTERATION_API } from '../constants';


// const ALTERATION_API = `http://qa.rm.qualitapps.com/api/alteration`;
// const ALTERATION_API = `http://rmapi.geseme.com/api/alteration`
// const ALTERATION_API = `http://192.168.88.15:8080/api/alteration`;
// const ALTERATION_API = `http://dev.api.rmagile.qualitapps.com/api/alteration`;

class subComponent extends React.Component {

    constructor(props) {
        super(props); 
        this.showEditPopup = this.showEditPopup.bind(this);
        this.aterationValidation = this.aterationValidation.bind(this)
        this.validForm = this.validForm.bind(this)
      }

    state = {
        loadAddPopup: false,
        bilateral: false,
        alteration_id: '',
        alteration_name: '',
        cie: '',
        recommendation_spanish: '',
        recommendation_catalan: '',
        recommendation_english: '',
        free1: '',
        loadDeletePopup: false,
        deleteAleration: {},
        loadEditPopup: false,
        editAleration: {},
        subComponentId: '',
        alterationDefaultId: '',
        loadSubAlterationPopup: false,
        subAlterationCie: '',
        subAlterationFree1: '',
        subAlterationRecommendationCatalan: '',
        subAlterationRecommendationEnglish: '',
        subAlterationRecommendationSpanish: '',
        subAlterationId: '',
        subAlterationName: '',
        subAlterationAlterations: [],
        subAlteration_Id: '',
        alterationDefaultIdpatch: '',
        formValidation: true
    }

    componentDidUpdate(prevState, nextState){
        /* if ( nextState.formValidation === this.state.formValidation){
             if(this.state.alteration_id !== '' && this.state.alteration_name !== '') {
                console.log('')
                // this.setState({
                //     formValidation : false
                // })
                return false
            } else {
                // this.setState({
                //     formValidation : true
                // })
                return true
            }
        } */
    }

    validForm = () => {
        if(this.state.alteration_id !== '' && this.state.alteration_name !== '') {
            return false
        } else {
            return true
        }
    }

    loadEditPopup = async () => {
        this.clearStates();
        this.setState({
            loadAddPopup: true
        })
    }

    loadSubAlterationEditPopup = async (currentSelected, subComponentId) => {
        this.setState({
            loadSubAlterationPopup: true,
            subAlterationCie: currentSelected.cie,
            subAlterationFree1: currentSelected.free1,
            subAlterationRecommendationCatalan: currentSelected.recommendation_catalan,
            subAlterationRecommendationEnglish: currentSelected.recommendation_english,
            subAlterationRecommendationSpanish: currentSelected.recommendation_spanish,
            subComponentId: subComponentId,
            subAlterationId: currentSelected.id,
            subAlterationName: currentSelected.name,
            subAlterationAlterations: currentSelected.alterations,
            subAlteration_Id: currentSelected._id
        })
    }

    closeEditPopup = async () => {

        this.setState({
            loadAddPopup: false,
            loadDeletePopup: false,
            loadEditPopup: false,
            loadSubAlterationPopup: false
        })
    }

    loadDeletePopup = async (currentSelected) => {
        this.setState({
            loadDeletePopup: true,
            deleteAleration: currentSelected
        })
    }

    showEditPopup  =(currentSelected, subComponentId) => {

        this.setState({
            loadEditPopup: true,
            alteration_name: currentSelected.name,
            cie: currentSelected.cie,
            bilateral: currentSelected.bilateral,
            recommendation_spanish: currentSelected.recommendation_spanish,
            recommendation_catalan: currentSelected.recommendation_catalan,
            recommendation_english: currentSelected.recommendation_english,
            free1: currentSelected.free1,
            alteration_id: currentSelected.alteration_id,
            subComponentId: subComponentId,
            alterationDefaultId: currentSelected.alteration_id
        })
    }

    handleBilateral = () => {
        let bilateral = !this.state.bilateral;
        this.setState({
            bilateral: bilateral
        });
    }

    addAlteration = async () => {

        let alterationObj = {
                "alteration_id" : this.state.alteration_id,
                "name" : this.state.alteration_name,
                "cie": this.state.cie,
                "recommendation_spanish": this.state.recommendation_spanish,
                "recommendation_catalan": this.state.recommendation_catalan,
                "recommendation_english": this.state.recommendation_english,
                "free1": this.state.free1,
                "data": {
                    "left":0,
                    "right":0
                }
            }
            
        let validateId = this.props.subComponent.alterations;
        let alterationIdArray = [];
        validateId.map(function(obj) {
            alterationIdArray.push(obj.alteration_id)

         })

        let inArrayStatus = alterationIdArray.includes(this.state.alteration_id);
         if(inArrayStatus) {
            alert('ID de alteración ya existe')
         } else{

        Object.assign([...this.props.subComponent.alterations],{...alterationObj})
        let alt = this.props.subComponent.alterations

        this.props.subComponent.alterations.push(alterationObj)
        let saveObj = {
            "_id": this.props.alterationId,
            "component": this.props.selectedAlteration.component,
            "sub_components":this.props.alteration,
            "__v": this.props.selectedAlteration.__v
        }
        const putAPI = ALTERATION_API+'/'+this.props.alterationId;
        const token = localStorage.getItem('token');

        await fetch(putAPI, {

            method: 'PUT', 
            body: JSON.stringify(saveObj), 
            headers:{
              'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
          }).then(res => res.json())
          .then(async response => {
              if(response.status = 1) {
                this.setState({
                    alteration_id: '',
                    alteration_name: '',
                    cie: '',
                    recommendation_spanish: '',
                    recommendation_catalan: '',
                    recommendation_english: '',
                    free1: ''
                })
                this.updateResponseMethod()
                this.props.editSubComponent(response.data)
              }
          })
          .catch(error => console.error('Error:', error));
        }
    }

    deleteAlerationState =(alterationArray) => {
        this.setState({
            deleteAleration: alterationArray
        })
    }

    deleteAleration = async() => {
        let fullAlterationArray = this.props.subComponent.alterations

        fullAlterationArray = fullAlterationArray.filter(e => e !== this.state.deleteAleration)

        let beforeReplaceAlteration = this.props.subComponent

        beforeReplaceAlteration.alterations = fullAlterationArray;

        let afterAlteration = this.props.alteration;

        let i = afterAlteration.findIndex(o => o._id === beforeReplaceAlteration._id);
        if (afterAlteration[i]) { afterAlteration[i] = beforeReplaceAlteration } else { afterAlteration.push(beforeReplaceAlteration) };

        let saveObj = {
            "sub_components":afterAlteration
        }

        const putAPI = ALTERATION_API+'/'+this.props.alterationId;
        const token = localStorage.getItem('token');
        const response = fetch(putAPI, {
            method: 'PUT', 
            body: JSON.stringify(saveObj), 
            headers:{
              'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
          }).then(res => res.json())
          .then(response =>{
            this.updateResponseMethod()
            this.props.editSubComponent(response.data)
          })
          .catch(error => console.error('Error:', error));
    }

    updateResponseMethod() {
        this.setState({
            loadEditPopup: false,
            loadSubAlterationPopup: false,
            loadDeletePopup: false,
            loadAddPopup: false
        })
    }

    editSingleAlteration = async() => {
        
                let selectedAlteration  = this.props.selectedAlteration.sub_components;
                
                let selectedSubAlteration = selectedAlteration.filter(e => e._id === this.state.subComponentId)
                let alterationList = selectedSubAlteration[0].alterations;

                let editableAlteration = editableAlteration = alterationList.filter(e => e.alteration_id === this.state.alterationDefaultId)

                if(editableAlteration.length ==! 0 ){
                    editableAlteration[0].alteration_id  = this.state.alteration_id; 
                    editableAlteration[0].name = this.state.alteration_name;
                    editableAlteration[0].cie = this.state.cie;
                    editableAlteration[0].bilateral = this.state.bilateral;
                    editableAlteration[0].recommendation_catalan = this.state.recommendation_catalan;
                    editableAlteration[0].recommendation_english = this.state.recommendation_english;
                    editableAlteration[0].recommendation_spanish = this.state.recommendation_spanish;
                    editableAlteration[0].free1 = this.state.free1;
                    editableAlteration[0].data = {"left":0,"right":0}

                    this.props.subComponent.alterations = alterationList

                    let finalUpdatedObject = this.props.alteration;

                    for (let i=0; i<finalUpdatedObject.length; i++) {
                        if(finalUpdatedObject[i]._id == alterationList[0]._id){
                            finalUpdatedObject[i].alterations = alterationList
                        }
                    }
                    
                    let saveObj = {
                        "_id": this.props.alterationId,
                        "component": this.props.selectedAlteration.component,
                        "sub_components":finalUpdatedObject,
                        "__v": this.props.selectedAlteration.__v
                    }
                    const putAPI = ALTERATION_API+'/'+this.props.alterationId;
                    const token = localStorage.getItem('token');
                    await fetch(putAPI, {
                        method: 'PUT', 
                        body: JSON.stringify(saveObj), 
                        headers:{
                          'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                      }).then(res => res.json())
                      .then(response => {
                          this.updateResponseMethod()
                          this.props.editSubComponent(response.data)
                      })
                      .catch(error => console.error('Error:', error));
                }
    }

    editSubAlteration = async() => {

        const getAPI = ALTERATION_API+'/'+this.props.alterationName;
        const token = localStorage.getItem('token');

        await fetch (getAPI, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then(response => response.json())
        .then(data =>{
            
            if(data.status === 1) {
                let selectedAlteration  = data.data[0].sub_components;

                let selectedSubAlteration = selectedAlteration.filter(e => e._id === this.state.subComponentId)

                if(selectedSubAlteration.length ==! 0 ){
                    selectedSubAlteration[0].cie = this.state.subAlterationCie,
                    selectedSubAlteration[0].recommendation_spanish = this.state.subAlterationRecommendationSpanish,
                    selectedSubAlteration[0].recommendation_catalan = this.state.subAlterationRecommendationCatalan,
                    selectedSubAlteration[0].recommendation_english = this.state.subAlterationRecommendationEnglish,
                    selectedSubAlteration[0].free1 = this.state.subAlterationFree1,
                    selectedSubAlteration[0].id = this.state.subAlterationId,
                    selectedSubAlteration[0].name = this.state.subAlterationName,
                    selectedSubAlteration[0]._id = this.state.subAlteration_Id,
                    selectedSubAlteration[0].alterations = this.state.subAlterationAlterations

                    this.props.subComponent.free1 = selectedSubAlteration[0].free1
                    this.props.subComponent.recommendation_spanish = selectedSubAlteration[0].recommendation_spanish
                    this.props.subComponent.recommendation_catalan = selectedSubAlteration[0].recommendation_catalan
                    this.props.subComponent.recommendation_english = selectedSubAlteration[0].recommendation_english
                    this.props.subComponent.cie = selectedSubAlteration[0].cie
                    this.props.subComponent.id = selectedSubAlteration[0].id
                    this.props.subComponent.name = selectedSubAlteration[0].name
                    this.props.subComponent._id = selectedSubAlteration[0]._id
                    this.props.subComponent.alterations = selectedSubAlteration[0].alterations

                    let saveObj = {
                        "sub_components":this.props.alteration
                    }

                    const putAPI = ALTERATION_API+'/'+this.props.alterationId;

                    const response = fetch(putAPI, {
                        method: 'PUT', 
                        body: JSON.stringify(saveObj), 
                        headers:{
                          'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                      }).then(res => res.json())
                      .then(response => {
                            this.updateResponseMethod()
                            this.props.editSubComponent(response.data)
                      })
                      .catch(error => console.error('Error:', error));
                }

            }
        })
        .catch(error => console.error(error))
    }

    // aterationValidation(value){
    aterationValidation = (value) => {
        if(value === '') {
            return 'warning';
        }
    }

    clearStates = () => {
        this.setState({
            alteration_id: '',
            alteration_name: '',
            cie: '',
            recommendation_spanish: '',
            recommendation_catalan: '',
            recommendation_english: '',
            handleBilateral: false,
            free1: ''
        });
    }

    render() {
        return (
            <div>
                <h4>{this.props.subComponent.name} - {this.props.subComponent.id}
                        <button className={'btn btn-primary add-button-align'} key={this.props.subComponent.id} onClick={this.loadEditPopup.bind()}>Agregar</button>
                        <button className={'btn btn-primary add-button-align'} key={this.props.subComponent.name} onClick={(e) => this.loadSubAlterationEditPopup(this.props.subComponent, this.props.subComponent._id)}>Editart alteración</button>
                </h4>
                
                    { this.state.loadAddPopup === true &&
                    
                    <div className='static-modal'>
                    <Modal.Dialog>
                      <Modal.Header>
                        <Modal.Title>Agregar nueva alteración</Modal.Title>
                      </Modal.Header>
                  
                        <Modal.Body>
                            <Form>
                                <FormGroup controlId="alterationId" validationState={this.aterationValidation(this.state.alteration_id)}>
                                    <ControlLabel>Alteration ID</ControlLabel>{' '}
                                    <FormControl type="text" className={'form-h'} onChange={ 
                                        (e)=>this.setState({alteration_id:e.target.value})}/>
                                </FormGroup>{' '}
                                <FormGroup controlId="alterationName" className={'form-d'} validationState={this.aterationValidation(this.state.alteration_name)}>
                                    <ControlLabel>Alteration</ControlLabel>{' '}
                                    <FormControl type="text" className={'form-h'} 
                                    onChange={ 
                                        (e)=>this.setState({alteration_name:e.target.value})}
                                    />
                                </FormGroup>{' '}
                                <FormGroup controlId="cie" className={'form-d'}>
                                    <ControlLabel>CIE</ControlLabel>{' '}
                                    <FormControl type="text" className={'form-h'} 
                                    onChange={ 
                                        (e)=>this.setState({cie:e.target.value})}
                                    />
                                </FormGroup>{' '}
                                <FormGroup controlId="recomendation_spanish" className={'form-d'}>
                                    <ControlLabel>RECOMMENDATION SPANISH</ControlLabel>{' '}
                                    <FormControl type="text" className={'form-h'} 
                                    onChange={ 
                                        (e)=>this.setState({recommendation_spanish:e.target.value})}
                                    />
                                </FormGroup>{' '}
                                <FormGroup controlId="recomendation_catalan" className={'form-d'}>
                                    <ControlLabel>RECOMMENDATION CATALAN</ControlLabel>{' '}
                                    <FormControl type="text" className={'form-h'} 
                                    onChange={ 
                                        (e)=>this.setState({recommendation_catalan:e.target.value})}
                                    />
                                </FormGroup>{' '}
                                <FormGroup controlId="recomendation_english" className={'form-d'}>
                                    <ControlLabel>RECOMMENDATION ENGLISH</ControlLabel>{' '}
                                    <FormControl type="text" className={'form-h'} 
                                    onChange={ 
                                        (e)=>this.setState({recommendation_english:e.target.value})}
                                    />
                                </FormGroup>{' '}
                                <FormGroup controlId="free1" className={'form-d'}>
                                    <ControlLabel>FREE</ControlLabel>{' '}
                                    <FormControl type="text" className={'form-h'} 
                                    onChange={ 
                                        (e)=>this.setState({free1:e.target.value})}
                                    />
                                </FormGroup>{' '}
                            </Form>
                        </Modal.Body>
                  
                      <Modal.Footer>
                        <Button className={'btn btn-secondary'} onClick={ (e) => {this.closeEditPopup();}}>Cerar</Button>
                        <Button bsStyle='primary' onClick={ (e) => {this.addAlteration();}} disabled={this.validForm(this)}>Agregar</Button>
                      </Modal.Footer>
                    </Modal.Dialog>
                  </div>
                    }
                    { this.state.loadSubAlterationPopup === true &&
                    
                    <div className='static-modal'>
                    <Modal.Dialog>
                      <Modal.Header>
                        <Modal.Title>Editar</Modal.Title>
                      </Modal.Header>
                  
                        <Modal.Body>
                            <Form>
                                <FormGroup controlId="cie" className={'form-d'}>
                                    <ControlLabel>CIE</ControlLabel>{' '}
                                    <FormControl defaultValue={this.state.subAlterationCie}
                                        onChange={ 
                                        (e)=>this.setState({subAlterationCie:e.target.value})}/>
                                </FormGroup>{' '}
                                <FormGroup controlId="recomendation_spanish" className={'form-d'}>
                                    <ControlLabel>RECOMMENDATION SPANISH</ControlLabel>{' '}
                                    <FormControl defaultValue={this.state.subAlterationRecommendationSpanish}
                                        onChange={ 
                                        (e)=>this.setState({subAlterationRecommendationSpanish:e.target.value})}/>
                                </FormGroup>{' '}
                                <FormGroup controlId="recomendation_catalan" className={'form-d'}>
                                    <ControlLabel>RECOMMENDATION CATALAN</ControlLabel>{' '}
                                    <FormControl defaultValue={this.state.subAlterationRecommendationCatalan}
                                        onChange={ 
                                        (e)=>this.setState({subAlterationRecommendationCatalan:e.target.value})}/>
                                </FormGroup>{' '}
                                <FormGroup controlId="recomendation_english" className={'form-d'}>
                                    <ControlLabel>RECOMMENDATION ENGLISH</ControlLabel>{' '}
                                    <FormControl defaultValue={this.state.subAlterationRecommendationEnglish}
                                        onChange={ 
                                        (e)=>this.setState({subAlterationRecommendationEnglish:e.target.value})}/>
                                </FormGroup>{' '}
                                <FormGroup controlId="free1" className={'form-d'}>
                                    <ControlLabel>FREE</ControlLabel>{' '}
                                    <FormControl defaultValue={this.state.subAlterationFree1}
                                        onChange={ 
                                        (e)=>this.setState({subAlterationFree1:e.target.value})}/>
                                </FormGroup>{' '}
                            </Form>
                        </Modal.Body>
                  
                      <Modal.Footer>
                        <Button className={'btn btn-secondary'} onClick={ (e) => {this.closeEditPopup();}}>Cerar</Button>
                        <Button bsStyle='primary' onClick={ (e) => {this.editSubAlteration();}}>Agregar</Button>
                      </Modal.Footer>
                    </Modal.Dialog>
                  </div>
                    }
                {
                    // this.props.subComponent.alterations.map((alterationArray, alterationiteration) => {
                        this.props.subComponent.alterations.map((alterationArray, alterationiteration) => {
                        return(
                            
                            <div key = {alterationiteration}>
                            <div className={'row'}>
                                <div className={'col-md-6 componentStyle'}><p>{alterationArray.name} - {alterationArray.alteration_id}</p></div>
                                <div className={'col-md-6 componentStyle'}>
                                    <div className={'btn-margin'}>
                                        <button className={'btn btn-danger'} title='Eliminar' onClick={(e) => this.loadDeletePopup(alterationArray)}><Glyphicon glyph="glyphicon glyphicon-remove"/></button>
                                        <button className={'btn btn-primary delete-edit-gap'} title='Editar' onClick={() => this.showEditPopup(alterationArray, this.props.subComponent._id)} ><Glyphicon glyph="glyphicon glyphicon-edit"/></button>
                                    </div>
                                </div>
                            </div>
                
                                { this.state.loadDeletePopup === true &&
                                <div className="static-modal">
                                <Modal.Dialog>
                                  <Modal.Header>
                                    <Modal.Title>Eliminar alteración</Modal.Title>
                                  </Modal.Header>
                              
                                  <Modal.Body>¿Estás seguro de querer eliminar?</Modal.Body>
                              
                                  <Modal.Footer>
                                    <Button onClick={ (e) => {this.closeEditPopup();}}>Cerar</Button>
                                    <Button onClick={ (e) => {this.deleteAleration();}} bsStyle="primary">Eliminar</Button>
                                  </Modal.Footer>
                                </Modal.Dialog>
                              </div>
                                }
                                { this.state.loadEditPopup === true &&
                                <div className="static-modal">
                                <Modal.Dialog>
                                  <Modal.Header>
                                    <Modal.Title>Editar alteración</Modal.Title>
                                  </Modal.Header>
                              
                                  <Modal.Body>
                                    <Form>
                                            <FormGroup controlId="alteration_name" className={'form-d'} validationState={this.aterationValidation(this.state.alteration_name)}>
                                                <ControlLabel>Alteration Name</ControlLabel>{' '}
                                                <FormControl defaultValue={this.state.alteration_name}
                                                onChange={ 
                                                    (e)=>this.setState({alteration_name:e.target.value})}/>
                                            </FormGroup>{' '}
                                            <FormGroup controlId="alteration_id" className={'form-d'} validationState={this.aterationValidation(this.state.alteration_id)}>
                                                <ControlLabel>Alteration ID</ControlLabel>{' '}
                                                
                                                <FormControl readOnly  defaultValue={this.state.alteration_id}
                                                onChange={ 
                                                    (e)=>this.setState({alteration_id:e.target.value})}/> 

                                                    {/* <ControlLabel>{this.state.alteration_id}</ControlLabel>{' '} */}


                                            </FormGroup>{' '}


                                            <FormGroup controlId="cie" className={'form-d'}>
                                                <ControlLabel>CIE</ControlLabel>{' '}
                                                <FormControl defaultValue={this.state.cie} 
                                                onChange={ 
                                                    (e)=>this.setState({cie:e.target.value})}
                                            />
                                            </FormGroup>{' '}

                                            <FormGroup>
                                              <Checkbox inline defaultChecked={this.state.bilateral}
                                              onChange={this.handleBilateral}
                                              >Bilateral</Checkbox>{' '}
                                            </FormGroup>

                                            <FormGroup controlId="recomendation_spanish" className={'form-d'}>
                                                <ControlLabel>RECOMMENDATION SPANISH</ControlLabel>{' '}
                                                <FormControl defaultValue={this.state.recommendation_spanish}
                                                onChange={ 
                                                    (e)=>this.setState({recommendation_spanish:e.target.value})}
                                                />
                                            </FormGroup>{' '}
                                            <FormGroup controlId="recomendation_catalan" className={'form-d'}>
                                                <ControlLabel>RECOMMENDATION CATALAN</ControlLabel>{' '}
                                                <FormControl defaultValue={this.state.recommendation_catalan}
                                                onChange={ 
                                                    (e)=>this.setState({recommendation_catalan:e.target.value})}
                                                />
                                            </FormGroup>{' '}
                                            <FormGroup controlId="recomendation_english" className={'form-d'}>
                                                <ControlLabel>RECOMMENDATION ENGLISH</ControlLabel>{' '}
                                                <FormControl defaultValue={this.state.recommendation_english}
                                                onChange={ 
                                                    (e)=>this.setState({recommendation_english:e.target.value})}
                                                />
                                            </FormGroup>{' '}
                                            <FormGroup controlId="free1" className={'form-d'}>
                                                <ControlLabel>FREE</ControlLabel>{' '}
                                                <FormControl defaultValue={this.state.free1}
                                                onChange={ 
                                                    (e)=>this.setState({free1:e.target.value})}
                                                />
                                            </FormGroup>{' '}
                                    </Form>
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button onClick={ (e) => {this.closeEditPopup();}}>Cerar</Button>
                                    <Button onClick={ (e) => {this.editSingleAlteration();}} bsStyle="primary" disabled={this.validForm(this)}>Editar</Button>
                                  </Modal.Footer>
                                </Modal.Dialog>
                              </div>
                                }
                            </div>
                        )
                    })
                }
                <h4>CIE - {this.props.subComponent.cie}</h4>
                <h4>Recommendation Spanish - {this.props.subComponent.recommendation_spanish}</h4>
                <h4>Recommendation Catalan - {this.props.subComponent.recommendation_catalan}</h4>
                <h4>Recommendation English - {this.props.subComponent.recommendation_english}</h4>
                <h4>Free1 - {this.props.subComponent.free1}</h4>
            </div>
        );
    }
}

export default subComponent;



// WEBPACK FOOTER //
// ./src/components/subComponent.js